import { render, staticRenderFns } from "./ScanData.vue?vue&type=template&id=71aa1c52&"
import script from "./ScanData.vue?vue&type=script&lang=js&"
export * from "./ScanData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports